module.exports = __webpack_public_path__ + "img/consolidatedReport.c545a318.svg";